import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EquipmentsListComponent } from './components/equipments-list/equipments-list.component';
import { EquipmentDetailPageComponent } from './components/equipment-detail-page/equipment-detail-page.component';
import { AgendaComponent } from './components/agenda/agenda.component';

const routes: Routes = [
  {
    path: '',
    component: EquipmentsListComponent,
    data: { breadcrumb: 'Listado' }
  },
  {
    path: 'agenda',
    component: AgendaComponent,
    data: { breadcrumb: 'Agenda de Equipos' }
  },
  {
    path: ':id',
    component: EquipmentDetailPageComponent,
    data: { breadcrumb: 'Detalle de Equipo' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EquipmentsRoutingModule { }
